import { createSelector } from 'reselect';

const selectVariants = (state: any) => state.variants;

export const selectVariantsCurrentItem = createSelector([selectVariants], (variants) => variants.current);

export const selectVariantsListItems = createSelector([selectVariants], (variants) => variants.list);


export const selectVariantsItemById = (itemId: any) =>
    createSelector(selectVariantsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectVariantsQueryItems = createSelector([selectVariants], (variants) => variants.query);

export const selectVariantsCreatedItem = createSelector([selectVariants], (variants) => variants.create);

export const selectVariantsUpdatedItem = createSelector([selectVariants], (variants) => variants.update);

export const selectVariantsReadItem = createSelector([selectVariants], (variants) => variants.read);

export const selectVariantsDeletedItem = createSelector([selectVariants], (variants) => variants.delete);

export const selectVariantsSearchedItems = createSelector([selectVariants], (variants) => variants.search);

export const selectVariantsItemsCount = createSelector([selectVariants], (variants) => variants.count);

export const selectVariantsItemsFilter = createSelector([selectVariants], (variants) => variants.filter);